import Vue from 'vue';
import { Icon, Button, Hyperlink } from '@/components';
export default Vue.extend({
    components: { Icon, Button, Hyperlink },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        isOpen: false,
    }),
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.isOpen = val;
            },
        },
        isOpen: {
            immediate: true,
            handler(val) {
                this.$emit('input', val);
            },
        },
    },
});
